import { render, staticRenderFns } from "./EstoqueTransferencia.vue?vue&type=template&id=04eeb5b4&scoped=true"
import script from "./EstoqueTransferencia.vue?vue&type=script&lang=js"
export * from "./EstoqueTransferencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eeb5b4",
  null
  
)

export default component.exports